export class TestRunDocumentFile {
    FileName = '';
    ContentType = '';
    DisplayAs = '';
    Encoding = '';
    BomPresent = false;
    Content = '';
    ContentSize = 0;

    constructor(source?: Partial<TestRunDocumentFile>) {
        if (source) {
            Object.assign(this, source);
        }
    }
}
